import { ButtonProps } from '@pancakeswap/uikit'
import { useConnectModal } from '@rainbow-me/rainbowkit'
import { Button } from '@/components/ui/button'
import Trans from './Trans'
import { cn } from '@/lib/utils'

const ConnectWalletButton = ({ children, className }: ButtonProps) => {
  const { openConnectModal } = useConnectModal()

  return (
    <>
      <Button onClick={openConnectModal} className={cn(className)}>
        {children || <Trans>Connect Wallet</Trans>}
      </Button>
    </>
  )
}

export default ConnectWalletButton
